import { ControlButton } from "@vericus/cadmus-ui";

import { ToastBar as HotToastBar, Toast, toast } from "react-hot-toast";

interface Props {
  toast: Toast;
}

/**
 * Wrapped ToastBar from react-hot-toast with custom styling.
 */
export function ToastBar(props: Props) {
  const { toast: t } = props;
  return (
    <HotToastBar toast={t} position="bottom-right">
      {({ icon, message }) => (
        <>
          {icon}
          {message}
          {t.type !== "loading" && (
            <ControlButton
              onClick={() => {
                toast.dismiss(t.id);
              }}
              aria-label="Dismiss toast"
              hideTooltip
              icon={<CloseIcon />}
            />
          )}
        </>
      )}
    </HotToastBar>
  );
}

const CloseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 5.96973L1.5 0.469727C1.22386 0.193584 0.776142 0.193584 0.5 0.469727C0.223858 0.745869 0.223858 1.19358 0.5 1.46973L6 6.96973L0.5 12.4697C0.223858 12.7459 0.223858 13.1936 0.5 13.4697C0.776142 13.7459 1.22386 13.7459 1.5 13.4697L7 7.96973L12.5 13.4697C12.7761 13.7459 13.2239 13.7459 13.5 13.4697C13.7761 13.1936 13.7761 12.7459 13.5 12.4697L8 6.96973L13.5 1.46973C13.7761 1.19358 13.7761 0.745869 13.5 0.469727C13.2239 0.193584 12.7761 0.193584 12.5 0.469727L7 5.96973Z"
      fill="#9DADCA"
    />
  </svg>
);
